(function () {
  'use strict';

  var TYPE_NAMES = {
    mat: 'Tablecloths & Mats',
    racks: 'Racks & Pushers',
    case: 'Cases & Storage',
    shuffler: 'Shufflers',
    care: 'Care Kit'
  };

  var BACK_TARGETS = {
    sets: '/pages/sets',
    collections: '/pages/collections-directory',
    designs: '/pages/tile-designs',
    registry: '/pages/registry',
    clubs: '/pages/clubs',
    learn: '/pages/learn',
    accessories: '/pages/accessories',
    journal: '/pages/journal'
  };

  var TIER_NAMES = {
    paper: 'Paper Box Set',
    collector: 'Collector Box Set',
    heirloom: 'Heirloom Numbered Set'
  };

  function readParam(name) {
    var value = '';
    try {
      value = new URLSearchParams(window.location.search).get(name) || '';
    } catch (err) {
      value = '';
    }
    return String(value).trim();
  }

  // Never interpolate a caller-supplied value into a CSS selector: an invalid
  // selector throws and would break the whole page script. Match by attribute
  // value instead, and fail closed to "not found".
  function findByAttr(attr, value) {
    var nodes = null;
    try {
      nodes = document.querySelectorAll('[' + attr + ']');
    } catch (err) {
      return null;
    }
    if (!nodes) {
      return null;
    }
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute(attr) === value) {
        return nodes[i];
      }
    }
    return null;
  }

  function show(node, text) {
    if (!node) {
      return;
    }
    node.textContent = text;
    node.hidden = false;
  }

  function hide(node) {
    if (node) {
      node.hidden = true;
    }
  }

  var wood = readParam('wood');
  var tier = readParam('tier').toLowerCase();
  var edition = readParam('edition').toLowerCase();
  var design = readParam('design');
  var from = readParam('from').toLowerCase();
  var type = readParam('type').toLowerCase();
  var recordId = readParam('id');

  var hasType = Object.prototype.hasOwnProperty.call(TYPE_NAMES, type);
  var hosts = document.querySelectorAll('[data-tt-context]');

  Array.prototype.forEach.call(hosts, function (host) {
    var chips = [];
    if (wood) { chips.push('Collection: ' + wood); }
    if (tier) { chips.push('Set: ' + (TIER_NAMES[tier] || tier)); }
    if (edition) { chips.push('Edition: ' + (edition === 'us' ? 'US edition' : edition === 'cn' ? 'Chinese edition' : edition)); }
    if (design) { chips.push('Design: ' + design); }
    if (type) { chips.push('Accessory: ' + (hasType ? TYPE_NAMES[type] : type)); }
    if (recordId) { chips.push('Record: ' + recordId); }

    var bar = host.querySelector('[data-tt-context-bar]');
    if (bar) {
      if (chips.length) {
        // Showing a parameter is not the same as applying it as a filter.
        bar.textContent = chips.join(' \u00b7 ') + ' \u2014 read from the link, not applied as a filter';
        bar.hidden = false;
      } else {
        bar.hidden = true;
      }
    }

    var back = host.querySelector('[data-tt-context-back]');
    if (back) {
      var target = BACK_TARGETS[from];
      if (target) {
        back.setAttribute('href', target);
        back.textContent = 'Back to ' + from.replace(/-/g, ' ');
        back.hidden = false;
      } else {
        back.hidden = true;
      }
    }

    var typeNameNode = host.querySelector('[data-tt-type-name]');
    var typeDescNode = host.querySelector('[data-tt-type-desc]');
    if (hasType) {
      show(typeNameNode, TYPE_NAMES[type]);
    } else if (type) {
      show(typeNameNode, 'Not one of the five accessory categories');
      if (typeDescNode) {
        show(typeDescNode, 'The link asks for a category called "' + type + '". That is not a category on this page, so nothing is opened or filtered.');
      }
    }

    var wantedRecord = recordId || design;
    var recordNode = wantedRecord ? findByAttr('data-tt-record', wantedRecord) : null;
    var empty = host.querySelector('[data-tt-context-empty]');
    if (wantedRecord && !recordNode) {
      show(empty, 'No record matching ' + wantedRecord + ' is published here. Opening this link does not hold or reserve anything; the live catalogue decides what exists.');
    } else {
      hide(empty);
    }
  });

  // Real product variants: mark the one the link asks for, and refuse to fake a
  // selection when the product has no such combination.
  var variantNodes = document.querySelectorAll('[data-tt-variant]');
  if (variantNodes.length && (tier || edition)) {
    var matched = false;
    Array.prototype.forEach.call(variantNodes, function (node) {
      var nodeTier = (node.getAttribute('data-tt-variant-tier') || '').toLowerCase();
      var nodeEdition = (node.getAttribute('data-tt-variant-edition') || '').toLowerCase();
      var tierOk = !tier || nodeTier === tier;
      var editionOk = !edition || nodeEdition === edition;
      if (tierOk && editionOk) {
        node.setAttribute('aria-current', 'true');
        node.className += ' tt-chip--active';
        matched = true;
      }
    });
    var matchNote = document.querySelector('[data-tt-variant-match]');
    if (matched) {
      show(matchNote, 'Matched to a real configuration on this product. Nothing is placed in the cart; the choice is not pre-selected for you.');
    } else {
      show(matchNote, 'The link asks for ' + [tier ? 'set "' + (TIER_NAMES[tier] || tier) + '"' : '', edition ? 'edition "' + edition + '"' : ''].filter(Boolean).join(' and ') + ', but this product has no such variant. Nothing is selected.');
    }
  } else {
    hide(document.querySelector('[data-tt-variant-match]'));
  }

  if (hasType) {
    var typeAnchor = document.getElementById(type);
    if (typeAnchor) {
      typeAnchor.scrollIntoView();
    }
  }
  if (tier) {
    var tierAnchor = document.getElementById(tier);
    if (tierAnchor) {
      tierAnchor.scrollIntoView();
    }
  }
})();
